import React from 'react';
import { motion } from 'framer-motion';

export default function CardCarouselSkeleton() {
  return (
    <div className="relative w-full max-w-6xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-8">
        <motion.div
          className="h-8 w-48 bg-gray-600 rounded mx-auto mb-4"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        />
        <motion.div
          className="h-4 w-64 bg-gray-600 rounded mx-auto"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0.3 }}
        />
      </div>

      {/* Carousel Container */}
      <div className="relative overflow-hidden">
        <div className="flex gap-6">
          {Array.from({ length: 3 }).map((_, index) => (
            <motion.div
              key={index}
              className="flex-shrink-0 w-full md:w-1/2 lg:w-1/3"
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: index * 0.2 }}
            >
              <div className="bg-gray-600 rounded-lg aspect-video"></div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Navigation Dots */}
      <div className="flex justify-center mt-6 space-x-2">
        {Array.from({ length: 3 }).map((_, index) => (
          <motion.div
            key={index}
            className="h-3 w-3 rounded-full bg-gray-600"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity, delay: index * 0.1 }}
          />
        ))}
      </div>
    </div>
  );
}
